import { render, staticRenderFns } from "./AppsShopifyConnect.vue?vue&type=template&id=15caaad6&"
import script from "./AppsShopifyConnect.vue?vue&type=script&lang=js&"
export * from "./AppsShopifyConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports